export default __webpack_public_path__ + "static/media/Facilities-CACS-14.60c1e279.jpg";